import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../store/stores.js";
import { COLOR_ERROR_SOFT, COLOR_ERROR_SOFT_DEEP } from "../../../../../../style/antdTheme.js";
import { __ } from "../../../../../../utils/i18n.js";
const SubscriptionPastDuePaymentReminder = observer(({ subscription })=>{
    const { accountV2Store } = useStores();
    const productName = subscription.data.productPlan.product.name;
    const gradient = `linear-gradient(120deg, ${COLOR_ERROR_SOFT} 0%, ${COLOR_ERROR_SOFT_DEEP} 50%, ${COLOR_ERROR_SOFT} 100%)`;
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-expired-hero rc-account-v2-expired-hero--payment-failed",
        style: {
            background: gradient
        },
        children: [
            /*#__PURE__*/ _jsx(ExclamationCircleFilled, {
                className: "rc-account-v2-expired-hero__icon",
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-expired-hero__text",
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        className: "rc-account-v2-expired-hero__title",
                        children: __("Your %s subscription is at risk", productName)
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "rc-account-v2-expired-hero__body",
                        children: __("The subscription has already renewed, but the agreed payment didn't go through. Add a working payment method to restore updates, support, downloads, and license management.")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                size: "large",
                className: "rc-account-v2-expired-hero__cta",
                onClick: ()=>accountV2Store.openChangePaymentFor(subscription),
                style: {
                    color: COLOR_ERROR_SOFT
                },
                children: __("Update payment method")
            })
        ]
    });
});
export { SubscriptionPastDuePaymentReminder };
